import {
  isClusterManaged,
  isKentManagedCluster,
} from '@cast/shared-cluster-context-data-access';
import { Cluster } from '@cast/types';

export type ClusterStatusFilterGroup =
  | 'cast_ai_managed'
  | 'kent_managed'
  | 'read_only';

export const deriveClusterStatusFilterGroup = (
  cluster: Cluster
): ClusterStatusFilterGroup => {
  if (isKentManagedCluster(cluster)) {
    return 'kent_managed';
  }

  if (isClusterManaged(cluster)) {
    return 'cast_ai_managed';
  }

  return 'read_only';
};
